import { combineReducers } from 'redux';

import { AppState, ReducerApp } from './ReducerApp';
import { CategoryState, ReducerCategory } from './ReducerCategory';
import { FilterState, ReducerFilter } from './ReducerFilter';

const reducers = {
    ReducerApp,
    ReducerCategory,
    ReducerFilter,
};

export interface State {
    ReducerApp: AppState;
    ReducerCategory: CategoryState;
    ReducerFilter: FilterState;
}

export default combineReducers(reducers);
